var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (false)?_c('AjanlatBase',{attrs:{"titleExtra":_vm.titleExtra}},[_c('v-form',{ref:"ajanlat-adatokk",attrs:{"slot":"biztositoi-adatok"},slot:"biztositoi-adatok"},[_c('v-layout',{attrs:{"row":"","wrap":""}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }